<template>
    <Section width="md">
        <div class="container bank-cooperations">
            <div 
                v-if="$validateText(data.primary.title)"
                class="rich-text rich-text-mb-large"
                v-html="$prismic.asHtml(data.primary.title)" 
            />
            <div class="bank-cooperations-box">
                <div 
                    v-for="(image, index) in images" 
                    :key="index"
                >
                    <prismic-image
                        class="bank-cooperations-img"
                        :img="image.image"
                        w="200"
                        h="55"
                    />
                </div>
            </div>
        </div>
    </Section>
</template>
<script>
export default {
    props: {
        data: {
            type: Object,
            required: true
        }
    },
    computed: {
        images() {
            return this.data.items.filter(data => data.image.url);
        }
    }
};
</script>
<style lang='scss' scoped>
    .bank-cooperations {
        .rich-text {
            text-align: center;
        }
        div.bank-cooperations-box {
            display: flex;
            flex-wrap: wrap;
            max-width: 100%;
            justify-content: flex-start;
            align-items: center;
            text-align: center;
            row-gap: 2rem;
            @media screen and (min-width: 600px) {
                justify-content: center;
                row-gap: 3rem;
            }
        
            div {
                flex: 0 0 auto;
                width: 50%;
                @media screen and (min-width: 600px) {
                    width: 33.33333333%;
                }
                .bank-cooperations-img {
                    object-fit: contain;
                    width: 75%;
                    @media screen and (min-width: 600px) {
                        width: 100%;
                    }
                }
            }
        }
    }
</style>